// extracted by mini-css-extract-plugin
export var desktopServicesColumnsWrapper = "ServicesSection-module--desktopServicesColumnsWrapper--3W5SG";
export var mobileServicesColumn = "ServicesSection-module--mobileServicesColumn--HoGSF";
export var servicesColumnContainer = "ServicesSection-module--servicesColumnContainer--WBNFa";
export var servicesSection = "ServicesSection-module--servicesSection--EcoZd";